// extracted by mini-css-extract-plugin
module.exports = {"IconGrote":"WhatIs_IconGrote__346Vp","IconHand":"WhatIs_IconHand__26J4q","Columns":"WhatIs_Columns__1IJ7S","Row":"WhatIs_Row__NYQyI","Text":"WhatIs_Text__2yJPZ"};